import * as React from 'react';
import { Station, StationFactory } from '../../resource/'; 
import { IAuthProps, List, IListState, IListProps, SearchFilter, ValueStore } from '../../services/';

import { Form } from '@independent-software/typeui/controls/Form';
import { Dialog } from '@independent-software/typeui/controls/Dialog';
import { Panel } from '@independent-software/typeui/controls/Panel';
import { DataTable } from '@independent-software/typeui/controls/DataTable';
import { Tabs } from '@independent-software/typeui/controls/Tabs';
import { IconBar, Export } from '../../modules';
import { Latitude, Longitude } from '@independent-software/typeui/formatters/GIS';
import { Checkbox } from '@independent-software/typeui/controls/Checkbox';
import { Gate } from '../../controls/Gate';
import { MapStations } from './MapStations';

interface IListStationsProps extends IListProps {
  stationcategoryId?: number;
  /**
   * Event is fired when a station is clicked.
   */
  onClick?: (station:Station) => void;
}

interface IListStationsState extends IListState<Station> {
  time: number;
}

class ListStations extends List<Station, IListStationsProps, IListStationsState> {
  constructor(props: IAuthProps & IListStationsProps) {
    super(props, StationFactory, 'name', 'asc');

    // Initialize state (list initializes its own part of the state):
    this.state = {
      ...this.state,
      time: 0
    };

    if(this.props.stationcategoryId) {
      this.setFilter('stationcategory', 'eq', { id: this.props.stationcategoryId }, true);
    }       
  }

  handleSearch = (value:string) => {
    this.setFilter('q', 'like', value);
    let d = new Date();
    // Force map component to reload markers:
    this.setState({ time: d.getTime() });
  }  

  private handleTabChange = (index: number) => {
    ValueStore.set("list_stations", index);
  }

  render() {
    let p = this.props;

    let filter = 
    <React.Fragment>
      <Panel.Content>
        <Form.Uncontrolled hint="Type to search records">
          <SearchFilter value={this.getFilter('q', 'like')} onSearch={this.handleSearch}/>
        </Form.Uncontrolled>
      </Panel.Content>
      <Panel.Footer>
        <div style={{display: "flex", justifyContent: 'space-between'}}>
          <Gate auth={p.auth} right='can_delete_stations'>
            <Form.Uncontrolled>
              <Checkbox label="Trash" name="trash" type="toggle" checked={this.getTrash()} onChange={this.handleTrash}/>
            </Form.Uncontrolled>
          </Gate>
          <Export onExport={this.handleExport}/>
        </div>
      </Panel.Footer>      
    </React.Fragment>

    return (
      <React.Fragment>
        <IconBar>
          <Panel.Icon icon="tools" width={300}>
            {filter}
          </Panel.Icon>
        </IconBar> 
        {/* small spacer to position tab content under iconbar */}
        <div style={{height: '8px', fontSize: '0px'}}></div>
        <Tabs underlined nohiddenrender active={ValueStore.get('list_stations', 0)} onTabChange={this.handleTabChange}>
          <Tabs.Pane label="List">
            <DataTable error={this.state.error} loading={this.state.loading} scrollTop={this.state.scrollTop} onScroll={this.handleScroll} data={this.state.items} onFetch={this.handleFetch} onClick={p.onClick} onOrder={this.handleOrder} order={this.getOrder()} dir={this.getDir()}>
              <DataTable.Column weight={1} label="Name" order="name" dir="asc">{(item:Station) => item.name}</DataTable.Column>
              <DataTable.Column weight={4} label="Description" order="description" dir="asc">{(item:Station) => item.description}</DataTable.Column>
              <DataTable.Column weight={1} label="Latitude" order="latitude" dir="asc">{(item:Station) => <Latitude value={item.latitude}/>}</DataTable.Column>
              <DataTable.Column weight={1} label="Longitude" order="longitude" dir="asc">{(item:Station) => <Longitude value={item.longitude}/>}</DataTable.Column>
              <DataTable.Column align="right" weight={1} label="Samples" order="samples_count" dir="desc">{(item:Station) => item.samples_count}</DataTable.Column>
            </DataTable>
          </Tabs.Pane>
          <Tabs.Pane label="Map">
            <MapStations auth={this.props.auth} query={this.state.query} time={this.state.time}/>
          </Tabs.Pane>
        </Tabs>
        <Dialog.Xhr open={this.state.exportError != null} error={this.state.exportError} onClose={this.handleCloseDialog}/>
      </React.Fragment>
    );
  }
}

export { ListStations };
